// @flow

import {
    SET_DRONE_LOCATION,
    GET_LAYERS_CONFIG,
    GET_LAYERS_CONFIG_SUCCESS,
    GET_LAYERS_CONFIG_FAIL,
    CENTER_MAP,
    CHANGE_ROTATION,
    SET_EXTENT,
    START_DRAWING_FLIGHT,
    FINISH_DRAWING_FLIGHT,
    CANCEL_DRAWING_FLIGHT,
    SET_OLLAYERS,
    SET_LABELS_CONFIG,
    SET_EDIT_MODE,
    DroneLocation,
    GET_BOX_EXTENT,
    BOX_EXTENT,
    MAP_MODE,
} from './../types/map';
import type { OlMap } from 'ol/map';

export type MapAction = {
    type: string,
    error?: string,
    olMap?: OlMap,
    markerAdded?: boolean,
    axiosInstance?: Object,
    droneLocation: DroneLocation,
    rotation?: number,
    center?: Array<number>,
    projectId?: number,
    points: Array<any>,
    flight: Flight,
    editMode: boolean,
    boxExtent?: OlGeomPolygon, 
}

export const setBoxExtent = (boxExtent: OlGeomPolygon): MapAction => ({
    type: GET_BOX_EXTENT,
    [BOX_EXTENT]: boxExtent
});

export const setRotation = (rotation: number): MapAction => ({
    type: CHANGE_ROTATION,
    rotation,
});

export const setDroneLocation = (droneLocation: DroneLocation) => ({
    type: SET_DRONE_LOCATION,
    droneLocation
})

export const centerMap = (center: Array<number>): MapAction => ({
    type: CENTER_MAP,
    center
});

export const setExtent = (extent: Array<number>): MapAction => ({
    type: SET_EXTENT,
    extent
});

export const startDrawingFlightGeometry = (flight: Flight): MapAction => ({
    type: START_DRAWING_FLIGHT,
    flight
});

export const finishDrawingFlightGeometry = (): MapAction => ({
    type: FINISH_DRAWING_FLIGHT
});

export const cancelDrawingFlightGeometry = (): MapAction => ({
    type: CANCEL_DRAWING_FLIGHT
});

export const setOlLayers = (olLayers): MapAction => ({
    type: SET_OLLAYERS,
    olLayers
});

export const getLayersConfig = (axiosInstance: Object, id: Number): MapAction => ({
    type: GET_LAYERS_CONFIG,
    id,
    axiosInstance
});

export const getLayersConfigSuccess = (layersConfig: Object): MapAction => ({
    type: GET_LAYERS_CONFIG_SUCCESS,
    layersConfig
});

export const getLayersConfigFail = (error: string): MapAction => ({
    type: GET_LAYERS_CONFIG_FAIL,
    error
});

export const setLabelsConfig = (labelsConfig: Object) => ({
    type: SET_LABELS_CONFIG,
    labelsConfig,
});

export const setEditMode = (editMode: boolean): MapAction => ({
    type: SET_EDIT_MODE,
    [MAP_MODE]: editMode,
    editMode,
});


// WEBPACK FOOTER //
// ./src/actions/map.jsx